export default __webpack_public_path__ + "0ee2237abf45dc31069026a3dd625819.svg";